import ProjectStatusPage from '@/features/project-status/ProjectStatusPage'
import { useAuthSession } from '@/lib/session'

export default function ClientProjectStatusPage() {
  const session = useAuthSession()
  const clientId = session?.currentClientId || ''
  return <ProjectStatusPage clientId={clientId} readOnly={false} />
}
